export const ADD_SHOWTIME_REQUEST = "@@adminReducer/ADD_SHOWTIME_REQUEST";
export const ADD_SHOWTIME__SUCCESS = "@@adminReducer/ADD_SHOWTIME__SUCCESS";
export const ADD_SHOWTIME__FAIL = "@@adminReducer/ADD_SHOWTIME__FAIL";

export const GET_CUMRAP = "@@adminReducer/GET_CUMRAP";
